import classNames from 'classnames'
import { Fragment, React } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import classes from '../../assets/scss/Layout.module.scss'
import { GoToRoute } from '../../lib/helpers'
import { BASE_MEDIA_QUERY } from '../../static/config'
import { Icons } from '../../static/icons'
import { menuVoices } from '../../static/menuVoices'
import { uiActions } from '../../store/ui'

const portalElement = document.getElementById('overlays')

const Sidenav = () => {
  const history = useHistory()
  const location = useLocation()
  const { sidenavOpened } = useSelector((state) => state.ui)
  const sidenavClassName = classNames(classes.sidenav)
  const dispatch = useDispatch()

  const toggleSidenav = () => {
    dispatch(uiActions.toggleSidenav(!sidenavOpened))
  }

  const navHandler = (link) => {
    GoToRoute(history, link)
    setTimeout(() => {
      if (!BASE_MEDIA_QUERY.matches) {
        toggleSidenav()
      }
    }, 150)
  }

  const Backdrop = (props) => {
    return (
      <div
        className="backdrop"
        onClick={props.onClose}
      />
    )
  }

  return (
    <Fragment>
      {!BASE_MEDIA_QUERY.matches && sidenavOpened && ReactDOM.createPortal(
        <Backdrop onClose={toggleSidenav} />,
        portalElement
      )}
      <CSSTransition
        classNames="sidenav_anim"
        timeout={{ enter: 200, exit: 200 }}
        in={sidenavOpened}
        unmountOnExit
      >
        <div className={sidenavClassName}>
          <div className={`${classes.sidenav_logo} p-text-center`}>
            <img src={Icons.logo} alt="" />
            <p className={`${classes.sidenav_company} p-mt-4`}>
              {process.env.REACT_APP_COMPANY_NAME}
            </p>
          </div>
          <div className={classes.sidenav_menu}>
            <ul>
              {menuVoices.map((item) => {
                return (
                  <li className={item.link === location.pathname ? classes.menu_active : ''} key={item.id} onClick={() => navHandler(item.link)}>
                    <img src={item.icon} alt={item.label} />
                    <p>{item.label}</p>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </CSSTransition>
    </Fragment>
  )
}

export default Sidenav
